export const UPDATE_LINKED_PRODUCTS = 'UPDATE_LINKED_PRODUCTS';

export const UPDATE_LINKED_PRODUCTS_DATA = 'UPDATE_LINKED_PRODUCTS_DATA';

/**
 * Update upsell products list (rewrite if already exists).
 * @param  {Array<String>} upsell List of products returned from fetch
 * @return {void}
 * @namespace Bodypwa/Store/LinkedProducts/Action/updateLinkedProducts */
export const updateLinkedProducts = (linkedProducts) => ({
    type: UPDATE_LINKED_PRODUCTS,
    linkedProducts
});

/** @namespace Bodypwa/Store/LinkedProducts/Action/updateLinkedProductsData */
export const updateLinkedProductsData = (
    items
) => ({
    type: UPDATE_LINKED_PRODUCTS_DATA,
    items
});
